import { connect } from 'react-redux'

import { hideRescheduleModal, setRescheduledViewed } from '../../dataStore/actions/ui/uiActions'
import RescheduleModal from './RescheduledModal'

const mapStateToProps = state => {
  const webcast = state.webcast.collection[`${state.config.channelId}${state.config.webcastId}`]
  return {
    webcast: (webcast && webcast.status.hasData) ? webcast.data : undefined
  }
}

const mapDispatchToProps = dispatch => ({
  setRescheduledViewed: () => dispatch(setRescheduledViewed()),
  hideRescheduleModal: () => dispatch(hideRescheduleModal())
})

export default connect(mapStateToProps, mapDispatchToProps)(RescheduleModal)
